import { style } from 'typestyle'

/* Styles ======================================================================================= */
import { StyleClass } from '../style-class'

/* Types ======================================================================================== */
type ClassNames = {
  /**
   * Base class for grid item
   */
  base: string
}

type ClassProps = {}

const getNames: (props: ClassProps, theme: any) => ClassNames = (props, theme) => {
  const base = style({
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 24,
  })

  return {
    base,
  }
}

/* Export ======================================================================================= */
export const gridItemClass = new StyleClass<ClassNames, ClassProps>(getNames)
